module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-down.a70005d6.svg";